<h4 class="widget__heading">Monthly Results</h4>
<div class="revenue-leaderboard" *ngIf="locations$ | async; let locations">
    <div
        class="revenue-leaderboard__section"
        *ngFor="let locationPerformance of performanceData; let i = index"
        [ngClass]="{
            'revenue-leaderboard__section--good':
                locationPerformance.estimate_amount >
                locationPerformance.orbit_target -
                    (locationPerformance.orbit_target -
                        locationPerformance.target) /
                        2,
            'revenue-leaderboard__section--fail':
                locationPerformance.estimate_amount <
                (locationPerformance.orbit_target -
                    (locationPerformance.orbit_target -
                        locationPerformance.target) /
                        2) *
                    0.9
        }"
    >
        <div *ngIf="i == 0" class="dashboard-leaderboard__ribbon">
            <div>
                1
                <sup>st</sup>
            </div>
        </div>

        <h4 class="revenue-leaderboard__section-heading">
            {{ locations[locationPerformance.location_id].name }}
        </h4>
    </div>
</div>
